import React, { ReactElement, useCallback, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import {
  StyledAnswer,
  StyledQuestionAnswerContainer,
  StyledQuestionLabel,
  StyledQuestionToggleContainer,
} from './FaqItem.styles';
import DownCaretIcon from 'app_previous/images/DownCaretIcon';
import { gTagEvent } from 'src/functions/googleAnalyticsHelper';

interface QuestionAnswerProps {
  question: string;
  answer: string;
}

const trackEvent = (question: string) => {
  if (typeof window === 'undefined') return;

  gTagEvent('Automatic_Link_Tracking', {
    category: `Link Click`,
    label: `FAQ | ${question}`,
  });
};

const FaqItem = ({ question, answer }: QuestionAnswerProps): ReactElement => {
  const [visible, setVisible] = useState(false);
  const parsedAnswer = documentToReactComponents(JSON.parse(answer));

  const onItemClick = useCallback(() => {
    if (!visible) {
      trackEvent(question);
    }

    setVisible(!visible);
  }, [visible, question]);

  return (
    <StyledQuestionAnswerContainer className='styled-question-answer-container'>
      <StyledQuestionToggleContainer onClick={() => onItemClick()}>
        <StyledQuestionLabel>{question}</StyledQuestionLabel>
        <DownCaretIcon inverted={visible} />
      </StyledQuestionToggleContainer>
      {visible && <StyledAnswer className='item-answer'>{parsedAnswer}</StyledAnswer>}
    </StyledQuestionAnswerContainer>
  );
};

export default FaqItem;
